export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";
export const LOGOUT = "LOGOUT";

export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const ADD_CRUSH_REQUEST = "ADD_CRUSH_REQUEST";
export const ADD_CRUSH_SUCCESS = "ADD_CRUSH_SUCCESS";
export const ADD_CRUSH_FAIL = "ADD_CRUSH_FAIL";

export const REMOVE_CRUSH_REQUEST = "REMOVE_CRUSH_REQUEST";
export const REMOVE_CRUSH_SUCCESS = "REMOVE_CRUSH_SUCCESS";
export const REMOVE_CRUSH_FAIL = "REMOVE_CRUSH_FAIL";

// profile page
export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL"

export const GET_PROFILES_REQUEST = "GET_PROFILES_REQUEST"
export const GET_PROFILES_SUCCESS = "GET_PROFILES_SUCCESS"
export const GET_PROFILES_FAIL = "GET_PROFILES_FAIL"

export const GET_INTERESTS_REQUEST = "GET_INTERESTS_REQUEST"
export const GET_INTERESTS_SUCCESS = "GET_INTERESTS_SUCCESS"
export const GET_INTERESTS_FAIL = "GET_INTERESTS_FAIL"

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL"

//profile page modals types
export const OPEN_EDIT_INTERESTS = "OPEN_EDIT_INTERESTS"
export const CLOSE_EDIT_INTERESTS = "CLOSE_EDIT_INTERESTS"

export const OPEN_EDIT_ABOUTME = "OPEN_EDIT_ABOUTME"
export const CLOSE_EDIT_ABOUTME = "CLOSE_EDIT_ABOUTME"


export const OPEN_EDIT_LOOKINGFOR = "OPEN_EDIT_LOOKINGFOR"
export const CLOSE_EDIT_LOOKINGFOR = "CLOSE_EDIT_LOOKINGFOR"

export const OPEN_EDIT_BIO = "OPEN_EDIT_BIO"
export const CLOSE_EDIT_BIO = "CLOSE_EDIT_BIO"